// extracted by mini-css-extract-plugin
module.exports = {"Key":"KeyValueItem_Key__3wWTB","Value":"KeyValueItem_Value__3MpvD","divider":"KeyValueItem_divider__2ML2j"};